module.exports = __webpack_public_path__ + "img/page5.d5762f98.png";